import React from "react";
import "./addCompany.css";
import OnboardingForm from "../Onboarding/OnboardingForm/OnboardingForm";

export default function AddCompanyLandingPage({ history }) {
  return <OnboardingForm addCompany history={history} />;
}
